var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-cell-image"},[_c('common-image',{attrs:{"image":_vm.src,"href":_vm.href,"is-absolute":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }